import { useNavigate } from 'react-router-dom';
import './menu-component.scss';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../../idioma-component/idioma-component';
import { FeatureFlag } from '../../../../feature-flag';
import { useEffect, useState } from 'react';

const MenuComponent = () => {

    const navigate = useNavigate();
    const { t } = useTranslation();
    const [modoSteamHabilitado, setModoSteamHabilitado] = useState(FeatureFlag.ModoSteamHabilitado);

    useEffect(function () {

    }, [])

    return (
        <header className="menu-component container">

 
           <div className="menu-opcoes row">
                <div className="col-12 col-lg-3" style={modoSteamHabilitado ? { display: 'none' } : { display: '' }}>
                    <button
                        onClick={() => navigate('/')}
                        className="btn-menu btn-menu-opcao-mobile form-control"
                    >
                        <span>
                            {t("MENU_HOME")}
                            <img src="./assets/Imagens/Loot_108.PNG" className="icone-menu-opcao img-fluid" />
                        </span>
                    </button>
                </div>

                <div className="col-12 col-lg-3" style={modoSteamHabilitado ? { display: 'none' } : { display: '' }}>
                    <button
                        onClick={() => navigate('/registro')}
                        className="btn-menu btn-menu-opcao-mobile form-control"
                    >
                        <span>
                            {t("MENU_REGISTER")}
                            <img src="./assets/Imagens/Loot_151.png" className="icone-menu-opcao img-fluid" />
                        </span>
                    </button>
                </div>

                <div className="col-12 col-lg-3" style={modoSteamHabilitado ? { display: 'none' } : { display: '' }}>
                    <button
                        onClick={() => navigate('/download')}
                        className="btn-menu btn-menu-opcao-mobile form-control"
                    >
                        <span>
                            {t("MENU_DOWNLOAD")}
                            <img src="./assets/Imagens/pirates_85_t.png" className="icone-menu-opcao img-fluid" />
                        </span>
                    </button>
                </div>

                <div className="col-12 col-lg-3" style={modoSteamHabilitado ? { display: 'none' } : { display: '' }}>
                    <button
                        onClick={() => navigate('/loja')}
                        className="btn-menu btn-menu-opcao-mobile form-control"
                    >
                        <span>
                            {t("MENU_POINTS_SHOP")}
                            <img src="./assets/Imagens/pirates_115_t.png" className="icone-menu-opcao img-fluid" />
                        </span>
                    </button>
                </div>


            </div>
        </header>
    );
};

export { MenuComponent };
